import { api } from "@/shared/api";

// local-only: C (drift) — generated KbDocPreferenceDto shape 不兼容(generated 是 {sceneTag, items: Record<string, never>[]}
// vs handwritten 单文档级 {docId, docName, boost, note, updatedAt});see proposals/2026-05-17-fe-generated-coverage-misc.md
export type KbDocPreference = {
  docId: string;
  docName: string;
  boost: number;
  note: string | null;
  updatedAt: string | null;
};

// local-only: B (backend schema gap) — PUT /tenant/knowledge/preferences body items
export type UpsertItem = {
  docId: string;
  boost: number;
  note?: string;
};

// local-only: B (backend schema gap) — PUT /tenant/knowledge/preferences 返
export type UpsertResult = {
  updated: number;
  deleted: number;
};

// local-only: B (backend schema gap) — /tenant/knowledge/preferences/audit 返
export type PreferenceAudit = {
  id: number;
  sceneTag: string;
  docId: string;
  action: "insert" | "update" | "delete";
  boostBefore: number | null;
  boostAfter: number | null;
  noteBefore: string | null;
  noteAfter: string | null;
  updatedBy: string | null;
  createdAt: string;
};

/** 场景偏好下拉项:编码 + 中文名(1005,api `/preferences/scene-tag-options`,只给本行业 + 通用)。 */
export type SceneTagOption = { code: string; label: string };

export const preferenceService = {
  /**
   * 1005:改用带中文名的选项口。旧口 `/preferences/scene-tags` 只回编码且是全行业 ~100 个,
   * 下拉直出 cs_export_doc、hs_b2b_contract……(生产实测)。
   */
  listSceneTags: () =>
    api.get<SceneTagOption[]>("/tenant/knowledge/preferences/scene-tag-options"),
  list: (sceneTag: string) =>
    api.get<KbDocPreference[]>(
      `/tenant/knowledge/preferences?sceneTag=${encodeURIComponent(sceneTag)}`
    ),
  upsert: (sceneTag: string, items: UpsertItem[]) =>
    api.put<UpsertResult>("/tenant/knowledge/preferences", { sceneTag, items }),
  listAudit: (sceneTag?: string, docId?: string) => {
    const qs = new URLSearchParams();
    if (sceneTag) qs.set("sceneTag", sceneTag);
    if (docId) qs.set("docId", docId);
    const suffix = qs.toString();
    return api.get<PreferenceAudit[]>(
      `/tenant/knowledge/preferences/audit${suffix ? `?${suffix}` : ""}`
    );
  },
};
